import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leads-import',
  templateUrl: './leads-import.component.html',
  styleUrls: ['./leads-import.component.scss']
})
export class LeadsImportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
